
<template>
  <div class="company">
    <confirm ref="confirm"></confirm>
    <v-progress-linear
      v-show="progressBar"
      slot="progress"
      color="blue"
      indeterminate
    />

    <v-container class="my-1">
      <v-layout row Wrap>
        
        <v-flex xs12 sm12 lg12
          ><v-card-text
            v-text="PageTitle"
            class="subtitle-1 indigo--text"
          ></v-card-text>
        </v-flex>


      </v-layout>

      <v-layout row Wrap>
        <v-flex xs1 sm1 lg1> </v-flex>
        <v-flex xs2 sm3 lg2>
          <v-card-actions>
            <v-btn
              color="blue darken-1"
              text
              @click="editnow"
              :disabled="WhenEdit || !DataReady"
              v-bind:class="{
                'd-none': WhenEdit || this.$route.params.Company_ID == '0',
              }"
            >
              <v-icon>mdi-pencil</v-icon>
              Edit
            </v-btn>

            <v-btn
              color="green darken-1"
              text
              @click="savenow"
              :disabled="!WhenEdit || !DataReady"
              v-bind:class="{ 'd-none': !WhenEdit }"
            >
              <v-icon>mdi-update</v-icon>
              Save
            </v-btn>
          </v-card-actions>
        </v-flex>
        <v-flex xs1 sm1 lg1> </v-flex>
        <v-flex xs3 sm3 lg2>
          <v-card-actions>
            <v-btn
              color="green darken-1"
              text
              @click="addnewnow"
              :disabled="WhenEdit || !DataReady"
              v-bind:class="{ 'd-none': WhenEdit }"
            >
              <v-icon>mdi-new-box</v-icon>
              New
            </v-btn>
          </v-card-actions>
        </v-flex>
        <v-flex xs1 sm1 lg1> </v-flex>

        <v-flex xs2 sm3 lg2>
          <v-card-actions>
            <v-btn
              color="red darken-1"
              text
              @click="deletenow"
              :disabled="WhenEdit || !DataReady"
              v-bind:class="{ 'd-none': WhenEdit }"
            >
              <v-icon>mdi-delete</v-icon>
              Delete
            </v-btn>

            <v-btn
              color="orange darken-1"
              text
              @click="cancelnow"
              :disabled="!WhenEdit || !DataReady"
              v-bind:class="{ 'd-none': !WhenEdit }"
            >
              <v-icon>mdi-cancel</v-icon>
              Cancel
            </v-btn>
          </v-card-actions>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs1 sm1 lg1> </v-flex>
        <v-flex xs11 sm11 lg8>
          <v-text-field
            v-model="Company_Name"
            label="Company"
            filled
            :readonly="!WhenEdit"
          >

          <template v-slot:append>
              <v-btn
                color="blue darken-1"
                text
                @click="gotoactivity"
                :disabled="WhenEdit"
              >
                <v-icon>list</v-icon>
                A
              </v-btn>
            </template>
          </v-text-field>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs1 sm1 lg1> </v-flex>
        <v-flex xs11 sm3 lg2>
          <v-text-field
            v-model="Company_Code"
            label="Code"
            :disabled="!WhenEdit"            
          ></v-text-field>
        </v-flex>
        <v-flex xs1 sm1 lg1> </v-flex>
        <v-flex xs11 sm3 lg2>
          <v-text-field
            v-model="Sector"
            label="Sector"
            :disabled="!WhenEdit"
          ></v-text-field>
        </v-flex>
        <v-flex xs1 sm1 lg1> </v-flex>
        <v-flex xs11 sm3 lg2>
          <v-text-field v-model="Company_ID" label="ID" disabled>
          </v-text-field>
        </v-flex>
        <v-flex xs1 sm1 lg1> </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs1 sm1 lg1> </v-flex>
        <v-flex xs11 sm3 lg2 v-b>
          <v-select
            v-model="Company_Status"
            :items="statusesoptions"
            label="Status"
            :disabled="!WhenEdit"
          ></v-select>
        </v-flex>
        <v-flex xs1 sm1 lg1> </v-flex>
        <v-flex xs11 sm3 lg2>
          <v-select
            v-model="Acc_Attribute"
            :items="attributesoptions"
            label="Attribute"
            :disabled="!WhenEdit"
          >
          </v-select>
        </v-flex>
        <v-flex xs1 sm1 lg1> </v-flex>
        <v-flex xs11 sm3 lg2>
          <v-select
            v-model="Acc_Type"
            :items="typesoptions"
            label="Type"
            :disabled="!WhenEdit"
          >
          </v-select>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs1 sm1 lg1> </v-flex>
        <v-flex xs11 sm11 lg8>
          <v-select
            v-model="Acc_Tags"
            :items="tagsoptions"
            label="Tags"
            :disabled="!WhenEdit"
            outlined
            chips
            multiple
          >
          </v-select>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs1 sm1 lg1> </v-flex>
        <v-flex xs11 sm5 lg3>
          <v-text-field
            v-model="Start_date"
            label="Start Date"
            type="date"
            :disabled="!WhenEdit"
          ></v-text-field>
        </v-flex>
        <v-flex xs1 sm1 lg1> </v-flex>
        <v-flex xs11 sm5 lg4>
          <v-text-field
            v-model="Renewal_Date"
            label="Renewal Date"
            type="date"
            :disabled="!WhenEdit"
          ></v-text-field>
        </v-flex>
        <v-flex xs1 sm1 lg1> </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs1 sm1 lg1> </v-flex>
        <v-flex xs11 sm5 lg3>
          <v-text-field
            v-model.number="Last_paid"
            label="Last Paid Amount"
            prefix="R"
            clearable
            :disabled="!WhenEdit"
            @keypress="checknumeric"
            @change="leavingnumeric"
          ></v-text-field>
        </v-flex>
        <v-flex xs1 sm1 lg1> </v-flex>
        <v-flex xs11 sm5 lg4>
          <v-text-field
            v-model="Last_paid_date"
            label="Last paid date"
            type="date"
            :disabled="!WhenEdit"
          ></v-text-field>
        </v-flex>
        <v-flex xs1 sm1 lg1> </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs1 sm1 lg1> </v-flex>
        <v-flex xs11 sm5 lg3>
          <v-text-field
            v-model="Acc_Manager"
            label="Account Manager"
            :disabled="!WhenEdit"
          ></v-text-field>
        </v-flex>
        <v-flex xs1 sm1 lg1> </v-flex>
        <v-flex xs11 sm5 lg4>
          <v-text-field
            v-model="Acc_email"
            label="email"
            :disabled="!WhenEdit"
          ></v-text-field>
        </v-flex>
        <v-flex xs1 sm1 lg1> </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs1 sm1 lg1> </v-flex>
        <v-flex xs11 sm5 lg3>
          <v-text-field
            v-model="Address1"
            label="Address Line1"
            :disabled="!WhenEdit"
          ></v-text-field>
        </v-flex>
        <v-flex xs1 sm1 lg1> </v-flex>
        <v-flex xs11 sm5 lg4>
          <v-text-field
            v-model="Address2"
            label="Address Line2"
            :disabled="!WhenEdit"
          ></v-text-field>
        </v-flex>
        <v-flex xs1 sm1 lg1> </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs1 sm1 lg1> </v-flex>
        <v-flex xs11 sm5 lg3>
          <v-text-field
            v-model="Address3"
            label="Address Line3"
            :disabled="!WhenEdit"
          ></v-text-field>
        </v-flex>
        <v-flex xs1 sm1 lg1> </v-flex>
        <v-flex xs11 sm5 lg4>
          <v-text-field
            v-model="Address4"
            label="Address Line4"
            :disabled="!WhenEdit"
          ></v-text-field>
        </v-flex>
        <v-flex xs1 sm1 lg1> </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs1 sm1 lg1> </v-flex>
        <v-flex xs11 sm3 lg2>
          <v-text-field
            v-model="City"
            label="City"
            :disabled="!WhenEdit"
          ></v-text-field>
        </v-flex>
        <v-flex xs1 sm1 lg1> </v-flex>
        <v-flex xs11 sm3 lg2>
          <v-text-field
            v-model="PostalCode"
            label="Postal Code"
            :disabled="!WhenEdit"
          ></v-text-field>
        </v-flex>
        <v-flex xs1 sm1 lg1> </v-flex>
        <v-flex xs11 sm3 lg2 align-self-center>
          <v-text-field
            v-model="Country"
            label="Country"
            :disabled="!WhenEdit"
          ></v-text-field>
        </v-flex>
        <v-flex xs1 sm1 lg1> </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs1 sm1 lg1> </v-flex>
        <v-flex xs11 sm3 lg2>
          <v-text-field
            v-model="Username"
            label="User Name"
            :disabled="!WhenEdit"
          ></v-text-field>
        </v-flex>
        <v-flex xs1 sm1 lg1> </v-flex>
        <v-flex xs11 sm3 lg2 >
                        <div class="text-center d-flex align-center justify-space-around">

          <v-text-field
            v-model="Password"
            label="Password"
            type="password"
            :disabled="!WhenEdit"
         
          ></v-text-field>


                <v-tooltip left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      medium
                      color="green darken-2"
                      v-bind="attrs"
                      v-on="on"
                    >
                      mdi-eye-settings-outline
                    </v-icon>
                  </template>
                  <span>{{Password}} </span>
                </v-tooltip>

                        </div>

        </v-flex>
        <v-flex xs1 sm1 lg1> </v-flex>
        <v-flex xs11 sm3 lg2 align-self-center>
          <v-checkbox
            v-model="IP_Address"
            label="IP_Address"
            :disabled="!WhenEdit"
          ></v-checkbox>
        </v-flex>
        <v-flex xs1 sm1 lg1> </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs1 sm1 lg1> </v-flex>
        <v-flex xs11 sm3 lg2> </v-flex>
        <v-flex xs1 sm1 lg1> </v-flex>
        <v-flex xs11 sm3 lg2>
          <v-text-field
            v-model="Lastupdateby"
            label="Last Updated By"
            disabled
          ></v-text-field>
        </v-flex>
        <v-flex xs1 sm1 lg1> </v-flex>
        <v-flex xs11 sm3 lg2>
          <v-text-field v-model="Lastupdate" label="Last Update" disabled>
          </v-text-field>
        </v-flex>
      </v-layout>

    </v-container>

    <v-container>
      <v-layout row Wrap>
        <v-flex xs1 sm1 lg1></v-flex>
        <v-flex xs11 sm5 lg
          ><v-card-text 
            v-text="AudienceTitle"
            class="subtitle-1 indigo--text"

            
          ></v-card-text>



        </v-flex>
        <v-flex xs1 sm1 lg1></v-flex>
        <v-flex xs11 sm5 lg4>
                        <v-btn
                color="indigo"
                text
                @click="gotoaddaudience"
                :disabled="WhenEdit"
              >
                <v-icon>add</v-icon>
                Add an Audience
              </v-btn>

        </v-flex>



      </v-layout>

      <v-layout row Wrap>
        <v-flex xs1 sm1 lg1> </v-flex>

        <v-flex xs11 sm11 lg8>
          <v-data-table
            class="grey--text"
            :headers="audheaders"
            :items="audiences"
            item-key="Email_id"
            :hide-default-footer="true"
            :disable-pagination="true"
            :disable-sort="true"
            :disable-filtering="true"
            @click:row="gotoaudience"
          ></v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>



<script>
// @ is an alias to /src
import Confirm from "@/components/Confirm";
export default {
  watch: {
    $route() {
      this.refreshlist();
    },
  },
  components: { Confirm },
  data() {
    return {
      WhenEdit: false,
      DataReady: false,
      PageTitle: localStorage.getItem("CURPROFILE") + " Company",
      AudienceTitle: "Company Audience",
      Company_ID: 0,
      Company_Code: "",
      Company_Name: "",
      Company_Status: "",
      Acc_Attribute: "",
      Acc_Type: "",
      Acc_Tags: "",
      Sector: "",
      Acc_Manager: "",
      Acc_email: "",
      Start_date: "",
      Renewal_Date: "",
      Last_paid_date: "",
      Last_paid: "0.00",
      Username: "",
      Password: "",
      IP_Address: false,
      Address1: "",
      Address2: "",
      Address3: "",
      Address4: "",
      City: "",
      PostalCode: "",
      Country: "",
      Lastupdateby: "",
      Lastupdate: "",
      statusesoptions: [],
      attributesoptions: [],
      typesoptions: [],
      tagsoptions: [],
      allowedit: false,
    };
  },

  computed: {
    audheaders() {
      return [
        { text: "Person", value: "Person" },
        { text: "Title", value: "Title" },
        { text: "Salutation", value: "Salutation" },
        { text: "Mobile Number", value: "MobileNumber" },
        { text: "email", value: "email" },
        { text: "Status", value: "mc_status" },
      ];
    },
  },

  created() {
    this.refreshlist();
  },

  methods: {
    async refreshlist() {
      this.progressBar = true;
      this.DataReady = false;
      this.audiences = [];
      this.myJsonResp = await this.PostData(
        "GetCompany",
        JSON.stringify({
          curprofile: localStorage.getItem("CURPROFILE"),
          Company_ID: this.$route.params.Company_ID,
        })
      );
      this.progressBar = false;
      if (this.myJsonResp != "ERROR") {
        this.data = JSON.parse(this.myJsonResp);
        this.Company_ID = this.$route.params.Company_ID;
        this.Company_Code = this.data.Company_Code;
        this.Company_Name = this.data.Company_Name;
        this.Company_Status = this.data.Company_Status;
        this.Acc_Attribute = this.data.Acc_Attribute;
        this.Acc_Type = this.data.Acc_Type;
        this.Acc_Tags = this.data.ACC_TAGS;
        this.Sector = this.data.Sector;
        this.Acc_Manager = this.data.Acc_Manager;
        this.Acc_email = this.data.Acc_email;
        this.Start_date = this.data.Start_date;
        this.Renewal_Date = this.data.Renewal_Date;
        this.Last_paid_date = this.data.Last_paid_date;
        this.Last_paid = this.data.Last_paid;
        this.Username = this.data.Username;
        this.Password = this.data.Password;
        this.IP_Address = this.data.IP_Address;
        this.Address1 = this.data.Address1;
        this.Address2 = this.data.Address2;
        this.Address3 = this.data.Address3;
        this.Address4 = this.data.Address4;
        this.City = this.data.City;
        this.PostalCode = this.data.PostalCode;
        this.Country = this.data.Country;
        this.Lastupdateby = this.data.Lastupdateby;
        this.Lastupdate = this.data.Lastupdate;
        this.audiences = this.data["AUDIENCES"];
        this.statusesoptions = this.data["STATUSES"];
        this.attributesoptions = this.data["ATTRIBUTES"];
        this.typesoptions = this.data["TYPES"];
        this.tagsoptions = this.data["TAGS"];

        this.allowedit = this.data.Allowedit;
        this.WhenEdit = false;
        this.DataReady = true;
        if (this.$route.params.Company_ID == 0) {
          this.editnow();
        }
      }
    },
    async editnow() {
      if (this.allowedit == false) {
        await this.$refs.confirm.open(
          "Security",
          "Access Denied !",
          "",
          "Close",
          { color: "error" }
        );
        return;
      }
      //      if (this.Emailfield == 0) {
      //        setTimeout(() => {
      //          this.alloweditemail = true;
      //          this.$refs.email.$refs.input.focus();
      //        });
      //      } else {
      //        setTimeout(() => {
      //          this.alloweditemail = false;
      //          this.$refs.Title.$refs.input.focus();
      //        });
      //      }

      this.WhenEdit = !this.WhenEdit;
    },
    gotoaudience(row) {
      this.$router.push(
        "/Audience/" + row.Email_id + "/Company/" + this.Company_ID
      );
    },

    gotoactivity() {
      this.$router.push("/Activity/" + this.Company_ID + "/Activity_id/-1");
    },

    gotoaddaudience() {
      this.$router.push("/Audience/0/Company/" + this.Company_ID);
    },


async cancelnow() {
      this.WhenEdit = false;
      if (this.$route.params.Company_ID == 0) {
        this.$router.back();
      } else {
        this.refreshlist();
      }

      //if this.$route.params.Company_ID = 0 then go BACK
    },

    addnewnow() {
      this.$router.push("/Company/0");
      this.refreshlist();
    },

    async deletenow() {
      if (this.allowedit == false) {
        await this.$refs.confirm.open(
          "Security",
          "Access Denied !",
          "",
          "Close",
          { color: "error" }
        );
        return;
      }

      if (
        await this.$refs.confirm.open("Confirm", "Delete ?", "Yes", "No", {
          color: "error",
        })
      ) {
        this.progressBar = true;
        this.DataReady = false;
        this.myJsonResp = await this.PostData(
          "DeleteCompany",
          JSON.stringify({
            curprofile: localStorage.getItem("CURPROFILE"),
            Company_ID: this.$route.params.Company_ID,
          })
        );
        this.progressBar = false;
        if (this.myJsonResp != "ERROR") {
          this.data = JSON.parse(this.myJsonResp);
          await this.$refs.confirm.open("Information", "Deleted", "Close", "", {
            color: "info",
          });
        this.DataReady = true;

          this.$router.back();
        }
      }
    },

    async savenow() {
      this.progressBar = true;
      this.DataReady = false;
      this.myJsonResp = await this.PostData(
        "SaveCompany",
        JSON.stringify({
          curprofile: localStorage.getItem("CURPROFILE"),
          Company_ID: this.$route.params.Company_ID,
          Company_Code: this.Company_Code,
          Company_Name: this.Company_Name,
          Company_Status: this.Company_Status,
          Acc_Attribute: this.Acc_Attribute,
          Acc_Type: this.Acc_Type,
          Acc_Tags: this.Acc_Tags,
          Sector: this.Sector,
          Acc_Manager: this.Acc_Manager,
          Acc_email: this.Acc_email,
          Start_date: this.Start_date,
          Renewal_Date: this.Renewal_Date,
          Last_paid_date: this.Last_paid_date,
          Last_paid: this.Last_paid,
          Username: this.Username,
          Password: this.Password,
          IP_Address: this.IP_Address,
          Address1: this.Address1,
          Address2: this.Address2,
          Address3: this.Address3,
          Address4: this.Address4,
          City: this.City,
          PostalCode: this.PostalCode,
          Country: this.Country,
        })
      );
      this.progressBar = false;
      this.DataReady = true;
      if (this.myJsonResp != "ERROR") {
        this.WhenEdit = !this.WhenEdit;
        await this.$refs.confirm.open(
          "Information",
          "Company saved",
          "Close",
          "",
          {
            color: "info",
          }
        );
        this.data = JSON.parse(this.myJsonResp);
        if (this.$route.params.Company_ID == 0) {
          await this.$router.replace({
            path: "/Company/" + this.data.Company_ID,
          });
        }
        await this.refreshlist();
      }
    },

    checknumeric($event) {
      // console.log($event.keyCode); //keyCodes value

      let keyCode = $event.keyCode ? $event.keyCode : $event.which;

      // only allow number and one dot
      if (
        (keyCode < 48 || keyCode > 57) &&
        (keyCode !== 46 || String(this.Last_paid).indexOf(".") != -1)
      ) {
        // 46 is dot
        $event.preventDefault();
      }

      // restrict to 2 decimal places
      if (
        this.Last_paid != null &&
        String(this.Last_paid).indexOf(".") > -1 &&
        String(this.Last_paid).split(".")[1].length > 1
      ) {
        $event.preventDefault();
      }
    },
    leavingnumeric() {
      this.Last_paid = String(Number(this.Last_paid).toFixed(2));
    },
  },
};
</script>